import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';

export const getIsLoggedIn = () => {
  const accessToken = sessionStorage.getItem('access_token');

  return !isNil(accessToken) && !isEmpty(accessToken);
};
